export default "__VITE_ASSET__Cvbpd9PH__"